import { path } from 'ramda';
import React, { useEffect, useState } from 'react';
import { Create } from 'react-admin';
import useFirebaseToken from '../../bitComponents/utils/hooks/useFirebaseToken';
import { graphqlServiceRequest } from '../../bitComponents/utils/requests';
import { API_URL } from '../../constants/constants';
import AgencyBranchMutation from './AgencyBranchMutation';
import { latestBranchIdQuery } from './queries';

const AgenciesBranchCreate = (props) => {
  const { token } = useFirebaseToken();
  const [latestId, setLatestId] = useState(null);
  useEffect(() => {
    const fetchLatestId = async () => {
      const result = await graphqlServiceRequest(
        token,
        latestBranchIdQuery,
        API_URL
      );

      const resultId = path(
        ['data', 'agencyBranches', 'nodes', 0, 'id'],
        result
      );
      if (resultId) {
        setLatestId(resultId + 1);
      }
    };

    fetchLatestId();
  }, [token]);

  return (
    <Create {...props}>
      <AgencyBranchMutation initialValues={{ id: latestId }} {...props} />
    </Create>
  );
};

export default AgenciesBranchCreate;
